import { render, staticRenderFns } from "./headpiece.component.vue?vue&type=template&id=09305b28"
import script from "./headpiece.component.ts?vue&type=script&lang=ts&external"
export * from "./headpiece.component.ts?vue&type=script&lang=ts&external"
import style0 from "./headpiece.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports